import React from 'react';

import { IconButton, InputBase, makeStyles, Theme, createStyles } from '@material-ui/core';
import { FiSearch, FiX } from 'react-icons/fi';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

// The search pill over a chat list.
export const ChatSearchField: React.FC<Props> = ({ value, onChange, placeholder = 'Search' }) => {
  const classes = useStyles();

  return (
    <InputBase
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder={placeholder}
      className={classes.root}
      inputProps={{ 'aria-label': placeholder, type: 'search' }}
      startAdornment={<FiSearch size={18} className={classes.icon} />}
      endAdornment={
        value ? (
          <IconButton size="small" onClick={() => onChange('')} aria-label="Clear the search">
            <FiX size={16} />
          </IconButton>
        ) : undefined
      }
    />
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      height: 40,
      padding: '0 6px 0 14px',
      gap: 8,
      borderRadius: 20,
      fontSize: 15,
      backgroundColor: theme.palette.action.hover,
      border: '1px solid transparent',
      transition: 'border-color 150ms, background-color 150ms',
      '&.Mui-focused': {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
      },
      '& input::-webkit-search-cancel-button': { display: 'none' },
    },
    icon: { flex: 'none', color: theme.palette.text.secondary },
  })
);
